import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ImportLocationsProgressBar } from 'components';

import FileCardService from './service';
import CountNotFoundLocations from './CountNotFoundLocations';
import { RemoveImportButton } from './style';

const ImportProgressBar = ({
  id,
  pageId,
  fileName,
  percentComplete,
  notFoundDatapoints,
  processedCount: persistedProcessedCount,
  totalCount: persistedTotalCount,
  unprocessedCount: persistedUnprocessedCount,
  geocodedCount: persistedGeocodedCount,
  indexedCount: persistedIndexedCount,
  notFoundCount: persistedNotFoundCount,
  isActiveImport,
  liveProgress,
}) => {
  const { destroyImport } = FileCardService(id, pageId);
  const displayPercent = isActiveImport && liveProgress ? liveProgress.percent : percentComplete;
  const displayStatus = isActiveImport && liveProgress
    ? liveProgress.status
    : (percentComplete === 100 ? 'success' : 'active');
  const processedCount = liveProgress ? liveProgress.processedCount : persistedProcessedCount;
  const totalCount = liveProgress ? liveProgress.totalCount : persistedTotalCount;
  const unprocessedCount = liveProgress ? liveProgress.unprocessedCount : persistedUnprocessedCount;
  const geocodedCount = liveProgress ? liveProgress.geocodedCount : persistedGeocodedCount;
  const indexedCount = liveProgress ? liveProgress.indexedCount : persistedIndexedCount;
  const notFoundCount = liveProgress ? liveProgress.notFoundCount : persistedNotFoundCount;
  const requiresAddressLookup = liveProgress
    ? liveProgress.requiresAddressLookup
    : (isActiveImport && ((persistedUnprocessedCount || 0) > 0 || (persistedNotFoundCount || 0) > 0));

  const handleDestroyImport = (e) => {
    e.stopPropagation();

    destroyImport();
  };

  return (
    <Fragment>
      <ImportLocationsProgressBar
        fileName={fileName}
        percent={displayPercent}
        status={displayStatus}
        strokeColor="orange"
        processedCount={processedCount}
        totalCount={totalCount}
        unprocessedCount={unprocessedCount}
        geocodedCount={geocodedCount}
        indexedCount={indexedCount}
        notFoundCount={notFoundCount}
        requiresAddressLookup={requiresAddressLookup}
      />
      {notFoundDatapoints.totalCount > 0 && (
        <CountNotFoundLocations notFoundDatapoints={notFoundDatapoints} />
      )}
      <RemoveImportButton type="link" onClick={handleDestroyImport}>Cancel</RemoveImportButton>
    </Fragment>
  );
};

ImportProgressBar.propTypes = {
  id: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  percentComplete: PropTypes.number.isRequired,
  notFoundDatapoints: PropTypes.object.isRequired,
  processedCount: PropTypes.number,
  totalCount: PropTypes.number,
  unprocessedCount: PropTypes.number,
  geocodedCount: PropTypes.number,
  indexedCount: PropTypes.number,
  notFoundCount: PropTypes.number,
  isActiveImport: PropTypes.bool,
  liveProgress: PropTypes.object,
};

export default ImportProgressBar;
